import { Layout, Menu } from 'antd';
import {
  SearchOutlined,
  DatabaseOutlined,
  LineChartOutlined,
  DollarOutlined,
  SettingOutlined,
  QuestionCircleOutlined,
  LogoutOutlined,
  UserOutlined,
  MailOutlined,
  RadarChartOutlined,
  KeyOutlined
} from '@ant-design/icons';
import logo from '../assets/logo.jpeg';
import logoDashboard from '../assets/logo.webp';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { encryptData, decryptData } from '../middleware/encryption';

const { Sider } = Layout;

export default function Sidebar({ collapsed, onCollapse }) {
  const navigate = useNavigate();
  const location = useLocation();

  const role = sessionStorage.getItem('role');
  const email = sessionStorage.getItem('email');
   const token = sessionStorage.getItem('access_token');

  console.log('User Role:', role);
  console.log('User Email:', email);
  console.log('User Token:', token);

  const [userName, setUserName] = useState('');

  // 🔐 Redirect if not logged in
  useEffect(() => {
    if (!email && !token) {
      window.location.href = 'https://app.exellius.com/login';
    }
  }, [email, token]);

  // 🔥 Fetch user name
  useEffect(() => {
    if (!token || !email) return;

    fetch(
      `https://api.app.exellius.com/api/users/getUsersWithActivePlans?search=${email}&page=1&limit=1`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then(res => res.json())
      .then(data => {
        console.log('Fetched user info:', decryptData(data.data));
       
          setUserName(decryptData(data.data).users[0].name);
        
      })
      .catch(err => {
        console.error('Failed to fetch user info', err);
      });
  }, [email, token]);

  const getSelectedKey = () => {
    if (location.pathname.includes('/admin/import-data')) return '2';
    if (location.pathname.includes('/leads')) return '1';
    if (location.pathname.includes('/finder')) return '11';
    if (location.pathname.includes('/admin/user-lists')) return '3';
    if (location.pathname.includes('/admin/data-visualization')) return '4';
    if (location.pathname.includes('/admin/pricing-plan')) return '5';
    if (location.pathname.includes('/settings')) return '6';
    if (location.pathname.includes('/plans')) return '8';
    if (location.pathname.includes('/admin/data-overview')) return '9';
    if (location.pathname.includes('/support')) return '7';
    if (location.pathname === '/api') return '12';
    if (location.pathname === '/verify/email' || location.pathname.includes('/verify/result/') )  return '10';
    if (location.pathname === '/apiv1/dashboard' || location.pathname === '/apiv1/analytics/') return '12';
    if (location.pathname === '/apiv1/rapidapi-user') return '13';  
    if (location.pathname === '/verify/file') return '17';

    return '1';
  };

  const handleLogout = () => {
    sessionStorage.clear();
    navigate('/login');
  };

  return (
    <Sider
      className="custom-sider-menu"
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
      style={{ backgroundColor: '#9856f2', height: 'calc(125vh - 48px)' }}
      trigger={<span style={{ color: '#fff' }}>|||</span>}
    >
      <div className="logo" style={{ padding: '16px' }}>
        <img
          src={collapsed ? logo : logoDashboard}
          alt="Logo"
          style={{
            width: '100%',
            maxWidth: collapsed ? '50px' : '70%',
            padding: '5px',
            borderRadius: '10px',
            background: 'white',
          }}
        />
      </div>

      <Menu
        theme="dark"
        selectedKeys={[getSelectedKey()]}
        mode="inline"
        style={{ backgroundColor: '#9856f2' }}
      >
        <Menu.Item key="1" icon={<SearchOutlined />} onClick={() => navigate('/leads')}>
          Leads Finder
        </Menu.Item>

        <Menu.Item key="11" icon={<RadarChartOutlined />} onClick={() => navigate('/finder')}>
          Finder
        </Menu.Item>

        <Menu.Item key="10" icon={<MailOutlined />} onClick={() => navigate('/verify/email')}>
          Email Verifier
        </Menu.Item>
        <Menu.Item key="12" icon={<KeyOutlined />} onClick={() => navigate('/apiv1/dashboard')}>
          API Keys
        </Menu.Item>
       

        {role === 'user' && (
          <>
            <Menu.Item key="8" icon={<DollarOutlined />} onClick={() => navigate('/plans')}>
              Plans & Upgrade
            </Menu.Item>
            <Menu.Item key="7" icon={<QuestionCircleOutlined />} onClick={() => navigate('/support')}>
              Help & Support
            </Menu.Item>
            <Menu.Item key="6" icon={<SettingOutlined />} onClick={() => navigate('/settings')}>
              Settings
            </Menu.Item>
          </>
        )}

        {role === 'admin' && (
          <>
          <Menu.Item key="17" icon={<DatabaseOutlined />} onClick={() => navigate('/verify/file')}>
          Bulk Email Verification
        </Menu.Item>
           <Menu.Item key="13" icon={<KeyOutlined />} onClick={() => navigate('/apiv1/rapidapi-user')}>
          RapidAPI Users
        </Menu.Item>
            <Menu.Item key="2" icon={<DatabaseOutlined />} onClick={() => navigate('/admin/import-data')}>
              Import Data
            </Menu.Item>
            <Menu.Item key="3" icon={<UserOutlined />} onClick={() => navigate('/admin/user-lists')}>
              User Lists
            </Menu.Item>
            <Menu.Item key="4" icon={<LineChartOutlined />} onClick={() => navigate('/admin/data-visualization')}>
              Data Visualization
            </Menu.Item>
            <Menu.Item key="9" icon={<DatabaseOutlined />} onClick={() => navigate('/admin/data-overview')}>
              Database Overview
            </Menu.Item>
            <Menu.Item key="5" icon={<DollarOutlined />} onClick={() => navigate('/admin/pricing-plan')}>
              Pricing Plan
            </Menu.Item>
          </>
        )}

        {/* 👤 USER INFO */}
        <Menu.Item
          className="menu-white-bg"
          icon={
            <img
              src="/avatar.png"
              alt="Avatar"
              style={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                border: '2px solid orange',
              }}
            />
          }
          style={{
            position: 'absolute',
            bottom: 96,
            backgroundColor: '#ffffff',
            color: 'black',
            fontWeight: 600,
            marginLeft: 10,
            marginRight: 10,
          }}
        >
          {userName || email}
        </Menu.Item>

        <Menu.Item
          key="logout"
          icon={<LogoutOutlined />}
          onClick={handleLogout}
          style={{ position: 'absolute', bottom: 48 }}
        >
          Logout
        </Menu.Item>
      </Menu>
    </Sider>
  );
}
